import { getCustomFormConfig } from '../co2_custom/getCustomFormConfig';
import { StructureTool } from '../../../core/forms/helpers/structure_tool';

const STRUCTURES: any = {};

export function getFormRequired(modul: string, entity: string, data: any, dataGlobal: any): any {
    const config: any = getCustomFormConfig(entity, data, dataGlobal);
    const key: string = `${modul}_${entity}`;
    const required: any = {};

    if (!STRUCTURES[key]) {
        STRUCTURES[key] = getStructure(modul, entity);
    }
    const structure: any = STRUCTURES[key];

    (structure.ATTS || []).forEach((att: any) => {
        const hiddenConfig: boolean = (config[att.KEY || null] || {}).hidden === true;
        const requiredConfig: boolean = (config[att.KEY || null] || {}).required === true;

        if (
            (typeof att.HIDDEN === 'undefined' || +att.HIDDEN === 0 || att.HIDDEN.toString().toLowerCase() === 'no')
            && (
                (typeof att.REQUIRED !== 'undefined'
                    && (+att.REQUIRED === 1 || att.REQUIRED.toString().toLowerCase() === 'yes'
                        || att.REQUIRED.toString().toLowerCase() === 'key'
                    )
                )
                || requiredConfig
            )
            && typeof att.KEY !== 'undefined' && typeof att.NAME !== 'undefined' && hiddenConfig !== true
        ) {
            required[att.KEY] = { name: att.NAME, ...(!!att.OPTS && !att.OPTS.SELECT_DIALOG_FIELDS && { type: 'select' }) };
        }
    });

    return required;
}

function getStructure(modul: string, entity: string): any {
    return new StructureTool(modul).getStructure(modul, entity) || {};
}
